module.exports = __webpack_public_path__ + "img/14.79b0e027.jpg";